<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CopyBusiness')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
  >
    <el-form label-width="120px" label-position="left" style="width: 100%;margin-bottom: 5px">
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item :label="$t('CargoMsg.Cargo_BLNo')">
            <el-input v-model="filter.mbl" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <el-input v-model="filter.jobNo" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <cargo-ag-grid
      config-module="12011503"
      :wrap-text="true"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
    />
    <cargo-pagination
      v-show="total>0"
      no="pagination"
      config-module="12011503"
      :total="total"
      :page.sync="filter.pageNum"
      :limit.sync="filter.pageSize"
      @pagination="toQuery"
    />
    <span slot="footer">
      <el-button
        type="primary"
        @click="choose()"
      >{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getByCondition } from '@/api/seaExport/seaCargoDoc'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'CargoDocExtendHplCopyDialog',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50,
        mbl: '',
        jobNo: ''
      },
      total: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 150,
        context: {
          componentParent: this
        },
        onRowClicked: this.selectItemClickHandler,
        onRowSelected: this.selectItemClickHandler
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_BLNo'),
          field: 'mbl',
          width: 200
        }, {
          headerName: this.$t('SeaExport.ActualShipper'),
          field: 'actualShipperInfo',
          width: 200,
          cellRenderer: (params) => {
            const data = params.data
            let result = this.$t('SeaExport.ShipperName') + ': ' + data.actualShipperName + '\n'
            result += this.$t('SeaExport.ShipperAddress') + ': ' + data.actualShipperAddress + '\n'
            result += this.$t('SeaExport.ActualShipperCountry') + ': ' + data.actualShipperCountry + '\n'
            result += this.$t('SeaExport.ActualShipperCity') + ': ' + data.actualShipperCity + '\n'
            result += this.$t('SeaExport.ShipperZipCode') + ': ' + data.actualShipperPostalCode + '\n'
            result += this.$t('SeaExport.EORICode') + ': ' + data.actualShipperCodeForManifest
            return result
          }
        }, {
          headerName: this.$t('SeaExport.ActualConsignee'),
          field: 'actualConsigneeInfo',
          width: 200,
          cellRenderer: (params) => {
            const data = params.data
            let result = this.$t('SeaExport.ConsigneeName') + ': ' + data.actualConsigneeName + '\n'
            result += this.$t('SeaExport.ConsigneeAddress') + ': ' + data.actualConsigneeAddress + '\n'
            result += this.$t('SeaExport.ActualRecipientCountry') + ': ' + data.actualConsigneeCountry + '\n'
            result += this.$t('SeaExport.ActualRecipientCity') + ': ' + data.actualConsigneeCity + '\n'
            result += this.$t('SeaExport.ConsigneeZipCode') + ': ' + data.actualConsigneeCodeForManifest + '\n'
            result += this.$t('SeaExport.EORICode') + ': ' + data.actualConsigneeIdNumber
            return result
          }
        }, {
          headerName: this.$t('SeaExport.Buyer'),
          field: 'buyInfo',
          width: 200,
          cellRenderer: (params) => {
            const data = params.data
            let result = this.$t('SeaExport.BuyerName') + ': ' + data.buyerName + '\n'
            result += this.$t('SeaExport.BuyerAddress') + ': ' + data.buyerAddress + '\n'
            result += this.$t('SeaExport.BuyerCountry') + ': ' + data.buyerCountry + '\n'
            result += this.$t('SeaExport.BuyerCity') + ': ' + data.buyerCity + '\n'
            result += this.$t('SeaExport.BuyerPostalCode') + ': ' + data.buyerPostalCode + '\n'
            result += this.$t('SeaExport.EORICode') + ': ' + data.buyerIdNumber
            return result
          }
        }, {
          headerName: this.$t('RailwayExport.BoxOwner2'),
          field: 'sellerInfo',
          width: 200,
          cellRenderer: (params) => {
            const data = params.data
            let result = this.$t('SeaExport.SellerName') + ': ' + data.sellerName + '\n'
            result += this.$t('SeaExport.SellerAddress') + ': ' + data.sellerAddress + '\n'
            result += this.$t('SeaExport.SellerCountry') + ': ' + data.sellerCountry + '\n'
            result += this.$t('SeaExport.SellerCity') + ': ' + data.sellerCity + '\n'
            result += this.$t('SeaExport.SellerPostalCode') + ': ' + data.sellerPostalCode + '\n'
            result += this.$t('SeaExport.EORICode') + ': ' + data.sellerIdNumber
            return result
          }
        }
      ],
      selectItem: null,
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
      this.selectItem = null
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.filter.mbl = ''
        this.filter.jobNo = ''
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    selectItemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectItem = event.data
    },
    toQuery() {
      const loading = getLoading4Cxt(this)
      getByCondition(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        this.selectItem = null
        this.gridOptions.api.clearFocusedCell()
        loading.close()
      })
    },
    choose() {
      if (!this.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$emit('selected', this.selectItem)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
